import "./rasp.scss";
import React from 'react';







const Rasp = () => {
  return (<div classname="rasp">
      <div className="rasp-header">Календарь стартов на 2026 год</div>
      <div className="rasp-table">
        <div className="rasp-line">
          <div className="rasp-item">Турмарафон</div>
          <div className="rasp-item">Дата</div>
          <div className="rasp-item">Километраж</div>
        </div>
        <div className="rasp-line one">
          <div className="rasp-item">Лыжный</div>
          <div className="rasp-item">14/15 февраля</div>
          <div className="rasp-item">20 / 30</div>
        </div>
        <div className="rasp-line two">
          <div className="rasp-item">Весенний</div>
          <div className="rasp-item">25/26 апреля</div>
          <div className="rasp-item">25 / 50</div>
        </div>
        <div className="rasp-line three">
          <div className="rasp-item">наСТОящий</div>
          <div className="rasp-item">30/21 мая</div>
          <div className="rasp-item">100</div>
        </div>
        <div className="rasp-line four">
          <div className="rasp-item">Летний</div>
          <div className="rasp-item">11/12 июля</div>
          <div className="rasp-item">25 / 50</div>
        </div>
        <div className="rasp-line six">
          <div className="rasp-item">Осенний</div>
          <div className="rasp-item">12/13 сентября</div>
          <div className="rasp-item">25 / 50</div>
        </div>
        <div className="rasp-line five">
          <div className="rasp-item">ДвухДневный</div>
          <div className="rasp-item">03/04 октября</div>
          <div className="rasp-item">100+</div>
        </div>
        <div className="rasp-line pink">
          <div className="rasp-item">ТурмарафонЧИК</div>
          <div className="rasp-item">14 ноября</div>
          <div className="rasp-item">норм</div>
        </div>
        <div className="rasp-line seven">
          <div className="rasp-item">Зимний</div>
          <div className="rasp-item">12/13 декабря</div>
          <div className="rasp-item">25 / 50</div>
        </div>
      </div>
      <div className="rasp-header">Прошедшие старты</div>
    </div>
  )
    ;
};

export default Rasp;